import apiClient from '../apiClient';

const item = async (id) => {
    const response = await apiClient.get(`/detail_ligne_devis/?ligne_devis_id=${id}`);
    return response.data;
};

async function update(ligneDevis) {
    const response = await apiClient.post('gestion_ligne_devis', ligneDevis);
    return response.data;
}

async function remove(ligneId) {
    return apiClient.post(`/supprimer_ligne_devis/?ligne_devis_id=${ligneId}`);
}

async function updateDeclinaisons(declinaisons) {
    const response = await apiClient.post('gestion_detail_ligne_devis', declinaisons);
    return response.data;
}

const ligneDevisActions = { item, update, remove, updateDeclinaisons };

export default ligneDevisActions;
